<template>
  <main>
    <v-row cols="12" v-if="news && news.length > 0">
      <v-col cols="1" class="d-flex align-center justify-center">
        <v-icon @click="scrollClickNews(-1, 520, $event)" class="arrow" color="blue" size="50">mdi-chevron-left</v-icon>
      </v-col>

      <v-col cols="10">
        <h3 class="h3-title">Feed de Notícias</h3>
        <v-row
            cols="12"
            id="list-news-content"
            class="list-promotions-content"
        >
          <v-col
              justify="center"
              @click="toNews(item)"
              class="ma-0 pa-0 mr-3 card-news-container"
              v-for="item in news"
              :key="item.id"
          >
            <v-card
                width="250"
                height="220"
                elevation="2"
                class="d-flex card-news"
            >
              <v-img
                  class="img"
                  :src="item.image"
                  height="100%"
                  width="100%"
              ></v-img>
            </v-card>

            <div>
              <p class="text-center mt-2 mx-2">
                {{ item.title }}
              </p>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="1" class="d-flex align-center justify-center">
        <v-icon @click="scrollClickNews(1, 520, $event)" class="arrow" color="blue" size="50">mdi-chevron-right</v-icon>
      </v-col>
    </v-row>

    <v-row class="sales-prepare-container">
      <v-col cols="1"></v-col>

      <v-col xl="10" lg="10" md="10" xs="10" sm="10" class="ma-0 pa-0">
        <v-card
            width="100%"
            transition="scale-transition"
            elevation="1"
            color="#FFFFFF"
        >
          <v-row cols="12">
            <v-col cols="12">
              <h3 class="ml-5 mb-4 mt-3">Vendas para preparar</h3>
              <v-divider></v-divider>
            </v-col>

            <v-col class="" cols="12" v-if="orders.length > 0">
              <!--<v-col cols="12" justify="center" class="d-flex align-center ma-0 pa-0">
                <v-col class="ma-0 pa-0" cols="3">
                  <p class="text-center"><strong>Pedido</strong></p>
                </v-col>

                <v-col class="ma-0 pa-0" cols="3">
                  <p class="text-center"><strong>Data de compra</strong></p>
                </v-col>

                <v-col class="ma-0 pa-0" cols="3">
                  <p class="text-center"><strong>Cliente</strong></p>
                </v-col>

                <v-col class="ma-0 pa-0" cols="3">
                  <p class="text-center"><strong>Total</strong></p>
                </v-col>
              </v-col>

              <v-col cols="12" v-for="(order, i) in orders" :key="`${order.id}_${i}`"
                     class="ma-0 pa-0 d-flex align-start">
                <v-col class="ma-0 pa-0" cols="3">
                  <p class="text-center mx-5">{{ order.orderCode }}</p>
                </v-col>

                <v-col class="ma-0 pa-0" cols="3">
                  <p class="text-center mx-3">{{ formatDate(order.created_at) }}</p>
                </v-col>

                <v-col class="ma-0 pa-0" cols="3">
                  <p class="text-center mx-3">{{ order.client.name }}</p>
                </v-col>

                <v-col class="ma-0 pa-0" cols="3">
                  <p class="text-center ">
                    {{
                      (order.fretePrice + order.totalPrice).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </p>
                </v-col>
              </v-col>-->

              <v-data-table
                  ref="table"
                  :loading="loading"
                  loading-text="Carregando..."
                  no-data-text="Nenhum pedido encontrado"
                  :headers="headers"
                  :items="orders"
                  class="elevation-0"
                  hide-default-footer
                  @click:row="handleRowClick"
                  style="cursor: pointer"
              >
                <template v-slot:[`item.totalPrice`]="{ item }">
                  {{
                    item.totalPrice.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </template>
              </v-data-table>
            </v-col>

            <v-col v-else cols="12">
              <p class="ml-5">Você não tem vendas para preparar</p>
            </v-col>

            <v-col cols="12">
              <v-divider></v-divider>
              <a href="/orders-resale" class="d-flex justify-space-between px-5 mt-6 align-center link-ver-compras">
                <p class="ml-5">Ver vendas</p>
                <v-icon color="blue" size="30">mdi-chevron-right</v-icon>
              </a>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!--<v-col xl="5" lg="5" md="10" xs="10" sm="10" class="ma-0 pa-0 ml-5">
        <v-card
            width="100%"
            transition="scale-transition"
            elevation="1"
            color="#FFFFFF"
        >
          <v-row cols="12">
            <v-col cols="12">
              <h3 class="ml-5 mb-4 mt-3">Reputação</h3>
            </v-col>

            <v-col class="ma-0 pa-0" cols="12">
              <div class="ml-5 mb-5">
                <v-rating
                    size="30"
                    readonly
                    v-model="user.reputationStars"
                    bg-color="orange-lighten-1"
                    color="normalred"
                ></v-rating>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>-->

      <v-col cols="1"></v-col>
    </v-row>

    <v-row cols="12" class="my-0 py-0" v-if="items && items.length > 0">
      <v-col cols="1" class="d-flex align-center justify-center mt-12">
        <v-icon @click="scrollClick(-1, 520, $event)" class="arrow" color="blue" size="50">mdi-chevron-left</v-icon>
      </v-col>

      <v-col cols="10">
        <h3 class="h3-title">Central de Promoções</h3>
        <v-row
            cols=" 12"
            id="list-promotions-content"
            class="list-promotions-content"
        >
          <v-col
              @click="toPromotion(item)"
              :style="item.active ? 'cursor: pointer;' : ''"
              class="ma-0 pa-0 mr-3 card-promotion-container"
              v-for="item in items"
              :key="item.id"
          >
            <v-card elevation="0" width="250" :disabled="!item.active" height="220" class="card-promotion">
              <div class="mt-3 ml-5 d-flex flex-column flex-wrap word-wrap">
                <span class="date-promotion">{{ formatDatePromotion(item) }}</span>
                <span class="name-promotion my-2">{{ item.name }}</span>
                <span
                    class="description-promotion">Ofereça um desconto que aparecerá em uma seção excclusiva do site
              </span>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="1" class="d-flex align-center justify-center mt-12">
        <v-icon @click="scrollClick(1, 520, $event)" class="arrow" color="blue" size="50">mdi-chevron-right</v-icon>
      </v-col>
    </v-row>

    <v-row cols="12" class="mt-5">
      <v-col cols="1"></v-col>

      <v-col class='ma-0 pa-0' cols="10">
        <h3>Gestão de Estoque</h3>
      </v-col>

      <v-col cols="1"></v-col>
    </v-row>

    <v-row cols="12" class="mt-5" justify="center">
      <v-col xl="5" lg="5" md="10" xs="10" sm="10" align="center" class="position-relative">
        <div class="estoque">
          <div id="chart"></div>
          <p class="text-center">{{ legend }}</p>
        </div>
      </v-col>

      <v-col xl="5" lg="5" md="10" xs="10" sm="10">
        <v-card width="100%" elevation="1" class="px-3">
          <div class="d-flex align-center justify-space-between pt-8">
            <div>
              <p> Métricas de negócio</p>
            </div>

            <div style="width: 50%">
              <v-select
                  class="pl-10 days"
                  :items="itemsFilterDias"
                  item-text="text"
                  item-value="value"
                  v-model="filterDias"
                  @change="getTotalSalesValue()"
              ></v-select>
            </div>
          </div>

          <div class="d-flex align-center justify-space-between mb-3">
            <div>
              <span> Vendas brutas </span><br/>
              <div class="d-flex align-center">
                <h2>
                  {{
                    totalGrossSalesInReais.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </h2>
                <div class="ml-1 align-center d-flex">
                  <v-icon v-if="totalGrossSalesInPercentage < 0" color="#FF0000" size="11">mdi-triangle</v-icon>
                  <v-icon v-else color="#008000" size="11">mdi-triangle</v-icon>
                  <span
                      :style="totalGrossSalesInPercentage < 0 ?  'color: #FF0000; margin-left: -5px' : 'color: #008000; margin-left: -5px'">
                    {{
                      (totalGrossSalesInPercentage).toFixed(1).toLocaleString("pt-br", {
                        currency: "BRL",
                      }).toString().replace('.', ',')
                    }}%
                  </span>
                </div>
              </div>
            </div>
          </div>

          <v-divider></v-divider>

          <div class="d-flex align-center justify-space-between mt-3 mb-3">
            <div>
              <span> Quantidade de vendas </span><br/>
              <div class="d-flex align-center">
                <h2>
                  {{
                    quantitySales
                  }}
                </h2>
                <div class="ml-1 align-center d-flex">
                  <v-icon v-if="quantitySalesPercentage < 0" color="#FF0000" size="11">mdi-triangle</v-icon>
                  <v-icon v-else color="#008000" size="11">mdi-triangle</v-icon>
                  <span
                      :style="quantitySalesPercentage < 0 ?  'color: #FF0000; margin-left: -5px' : 'color: #008000; margin-left: -5px'">
                    {{
                      (quantitySalesPercentage).toFixed(1).toLocaleString("pt-br", {
                        currency: "BRL",
                      }).toString().replace('.', ',')
                    }}%
                  </span>
                </div>
              </div>
            </div>
          </div>

          <v-divider></v-divider>

          <a href="/dash-resale" class="d-flex justify-space-between mt-6 align-center link-ver-compras">
            <p class="ml-1">Ver métricas</p>
            <v-icon color="blue" size="30">mdi-chevron-right</v-icon>
          </a>
        </v-card>
      </v-col>
    </v-row>

    <v-row cols="12" justify="center">
      <v-col xl="9" lg="9" md="10" xs="10" sm="10">
        <v-card elevation="1" width="100%" class="pa-3">

          <v-col cols="12">
            <h2>Central de Ajuda</h2>
          </v-col>
          <v-row class="pa-3" cols="12">
            <v-col cols="4">
              <img width="50" src="../../../assets/icone-question.png" alt="Central de Ajuda"/>
              <p>
                <strong> Central de Ajuda</strong>
              </p>
              <span>
                Confira as duvidas frequentes através de nosso <router-link to="/perguntasFrequentes">FAQ</router-link>
              </span>
            </v-col>

            <v-col cols="4">
              <img width="50" src="../../../assets/icone-de-email.png" alt="Suporte loja Impimax"/>
              <p>
                <strong> Suporte loja Impimax</strong>
              </p>
              <span>
                Entre em contato com o suporte pelo  <a href="mailto:marketplace@imprimax.com.br" >marketplace@imprimax.com.br</a>
              </span>
            </v-col>

            <v-col align="center" cols="4">
              <img width="150" height="150" src="../../../assets/atendente.png" alt="Suporte loja Impimax"/>
            </v-col>
          </v-row>
        </v-card>

      </v-col>
    </v-row>
  </main>
</template>

<script lang="js">
import ApiService from '../../../services/ApiService';
import Utils from "../../../Utils/FormatDate";

export default {
  name: "newsFeed",

  async created() {

  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    await this.listOrdersToPrepare();
    await this.listPromotions();
    await this.getStockPercentage();
    await this.getTotalSalesValue();
    await this.listNews();
  },

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      filters: false,
      activeTab: 0,
      news: [],
      pageSize: 15,
      headerProps: {sortByText: "Ordenar por"},
      user: null,
      legend: '',
      filter: {
        PageSize: 2000,
        page: 1,
        totalPages: 1,
      },
      filterTotalSalesValue: {
        resaleId: null,
        days: 0,
      },
      mesesAnos: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "outubro",
        "Novembro",
        "Dezembro",
      ],
      orders: [],
      componentKey: 1,
      headers: [
        {
          text: "Pedido",
          align: "center",
          class: "item",
          value: "orderCode",
          sortable: false,
        },
        {
          text: "Data de compra",
          class: "item",
          value: "created_at",
          align: "center",
          sortable: false,
        },
        {
          text: "Cliente",
          class: "item",
          value: "client.name",
          align: "center",
          sortable: false,
        },
        {
          text: "Total",
          class: "item",
          value: "totalPrice",
          align: "center",
          sortable: false,
        },
      ],
      items: [],
      filterDias: 30,
      itemsFilterDias: [
        {
          text: "Últimos 7 dias",
          value: 7
        },
        {
          text: "Últimos 15 dias",
          value: 15
        },
        {
          text: "Últimos 30 dias",
          value: 30
        },
      ],
      historicoskuLogs: [],
      resales: [],
      categories: [],
      subcategories: [],
      totalGrossSalesInReais: 0,
      totalGrossSalesInPercentage: 0,
      quantitySales: 0,
      quantitySalesPercentage: 0,
    }
  },

  methods: {
    showPhoto(image) {
      if (!!image && image.includes("Uploads/")) {
        const env_url = process.env.VUE_APP_BASE_URL;
        return env_url + image;
      } else {
        return image;
      }
    },

    scrollClick(direcao, px, event) {
      event.preventDefault();
      const maisVendidos = document.getElementById("list-promotions-content");
      maisVendidos.scrollLeft += px * direcao;
    },

    scrollClickNews(direcao, px, event) {
      event.preventDefault();
      const listNewsContent = document.getElementById("list-news-content");
      listNewsContent.scrollLeft += px * direcao;
    },

    formatDatePromotion(promotion) {
      const start = new Date(promotion.start)
      const end = new Date(promotion.end)
      if (start.getMonth() === end.getMonth()) {
        return `De ${start.getDate()} A ${end.getDate()} de ${this.mesesAnos[end.getMonth()]}`
      }
      return `De ${start.getDate()} ${this.mesesAnos[start.getMonth()]} A ${end.getDate()} de ${this.mesesAnos[end.getMonth()]}`
    },

    async listPromotions() {
      this.apiService.get('promotion/listAll', this.filter).then((response) => {
        console.log(response)
        this.items = response
      }).catch(() => {
      })
    },

    async listNews() {
      this.apiService.get('news/listAll').then((response) => {
        this.news = response.content
      }).catch(() => {
      })
    },

    async getTotalSalesValue() {
      this.filterTotalSalesValue.resaleId = this.user.id
      this.filterTotalSalesValue.days = this.filterDias

      this.apiService.post('resale/total-sales-value', this.filterTotalSalesValue).then((response) => {
        const {
          quantitySales,
          quantitySalesPercentage,
          totalGrossSalesInPercentage,
          totalGrossSalesInReais
        } = response.content2
        this.totalGrossSalesInReais = totalGrossSalesInReais
        this.totalGrossSalesInPercentage = totalGrossSalesInPercentage
        this.quantitySales = quantitySales
        this.quantitySalesPercentage = quantitySalesPercentage
      }).catch((error) => {
      })
    },

    async handleRowClick(item) {
      await this.$router.push({
        path: `/order-detail?id=` + item.id,
        params: item,
      });
    },

    async toNews(item) {
      await this.$router.push({
        path: `noticia`,
        query: {id: item.id},
      });
    },

    async toPromotion(item) {
      if (item.active) {
        await this.$router.push({
          path: `promotion-resale?details=true&id=${item.id}`,
          params: item,
        });
      }
    },

    async getStockPercentage() {
      this.apiService.get(`resaleproductsku/stock-percentage/${this.user.id}`)
          .then((response) => {
            const {percentage} = response
            this.showStockChart(percentage)
          }).catch(() => {
      })
    },

    async showStockChart(percentage) {
      let color = '#008000'
      this.legend = `Seu estoque esta excelente, continue assim para manter suas vendas!`
      if (percentage <= 50) {
        color = '#FF0000'
        this.legend = `Seu estoque está abaixo do mínimo. Você está perdendo vendas!`
      } else if (percentage <= 60) {
        color = '#FFD700'
        this.legend = `Seu estoque no mínimo, verifique para não perder venda!`
      }
      const options = {
        chart: {
          height: 280,
          type: "radialBar"
        },
        series: [percentage.toFixed(1)],
        colors: [color],
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 20,
              size: "50%"
            },

            dataLabels: {
              showOn: "always",
              name: {
                offsetY: -10,
                show: true,
                color: "#888",
                fontSize: "13px"
              },
              value: {
                offsetY: -5,
                color: "#111",
                fontSize: "30px",
                show: true
              }
            }
          }
        },

        stroke: {
          lineCap: "round",
        },
        labels: [""]
      };
      const chart = new ApexCharts(document.querySelector("#chart"), options);
      await chart.render();
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    async listOrdersToPrepare() {
      try {
        this.loading = true;
        this.apiService
            .get(`order/prepare?resaleId=${this.user.id}`)
            .then((response) => {
              const {orders} = response
              this.orders = orders;
            }).catch((errors) => {
          console.error(errors)
        });
        this.loading = false;
      } catch (e) {
        console.error(e)
      }
    },
  },

  watch: {}
};
</script>

<style scoped>
.link-ver-compras {
  text-decoration: none;
  color: blue;
}

.list-promotions-content {
  flex-wrap: nowrap !important;
  overflow: hidden;
  scroll-behavior: smooth;
  z-index: 0;
}

.card-promotion {
  border-radius: 5px !important;
  background: #FFFFFF !important;
  border-left: 5px solid blue !important;
  display: flex;
  align-items: start;
  flex-wrap: wrap;
}

.date-promotion {
  text-align: left !important;
  color: #3c4858;
  font-size: 13px;
  word-wrap: break-word !important;
}

.word-wrap {
  word-wrap: break-word !important;
  max-width: 250px !important;
  flex-wrap: wrap !important;
}

.name-promotion {
  text-align: left !important;
  color: #3c4858;
  font-size: 16px;
  font-weight: 700;
  word-wrap: break-word !important;
}

.description-promotion {
  text-align: left !important;
  color: #3c4858;
  word-wrap: break-word !important;
}

.sales-prepare-container {
  margin-top: -40px;
  margin-bottom: 20px;
}

.card-news-container {
  max-width: 250px !important;
  cursor: pointer;
}

.card-promotion-container {
  max-width: 250px !important;
}

.card-news > .img {
  border-radius: 5px !important;
}

.h3-title {
  margin-left: -10px;
  margin-bottom: -15px
}

.arrow {
  cursor: pointer;
}

.promotion {

  border-radius: 10px !important;
}

.blue-promotion {
  /* background: blue;
   width: 3% !important;
   border-radius: 10px 0 0 10px;*/
}

.estoque {
  width: 250px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  margin-left: -45px
}

.days {
  margin-top: -30px;
}
</style>
